var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M902.651,583.791c-27.204,-53.141 -51.229,-115.423 -107.92,-158.053c-39.936,-30.031 -95.916,-50.87 -180.724,-51.398c-81.72,-0.508 -138.695,28.696 -183.133,72.902c-7.337,7.298 -7.368,19.18 -0.07,26.516c7.299,7.337 19.18,7.368 26.517,0.07c37.94,-37.742 86.683,-62.423 156.452,-61.989c74.198,0.462 123.481,17.597 158.421,43.871c53.721,40.397 73.962,101.039 99.977,150.777c1.435,2.745 4.152,6.408 9.563,9.289c4.249,2.262 14.377,5.179 28.455,9.145c56.642,15.96 191.442,58.78 189.071,232.338c-2.685,196.509 -178.616,225.303 -193.061,227.336c-0.009,0.002 -592.219,-0.227 -592.219,-0.227c-11.426,-1.045 -161.705,-17.512 -162.786,-161.606c-0.823,-109.634 54.788,-154.386 111.443,-177.054c9.608,-3.844 14.287,-14.765 10.443,-24.373c-3.844,-9.608 -14.765,-14.288 -24.373,-10.443c-68.099,27.246 -136.001,80.371 -135.012,212.151c1.372,182.808 198.042,198.768 198.042,198.768c0.48,0.038 0.961,0.056 1.442,0.057l594.22,0.229c0.721,0 1.441,-0.041 2.156,-0.123c0,-0 223.938,-25.347 227.201,-264.203c3.054,-223.575 -189.854,-260.098 -234.105,-273.98Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M665.768,145.849c-252.707,-0 -457.873,178.069 -457.873,397.4c-0,219.33 205.166,397.399 457.873,397.399c-127.301,-65.736 -230.654,-221.175 -230.654,-397.399c0,-176.225 103.353,-331.664 230.654,-397.4Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "37.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1003);
export default __webpack_public_path__ + "static/media/1003.5055327eb8cd6cc271b2b504de82fbd1.svg";
export { ForwardRef as ReactComponent };